export const GET_GUIDES = 'GET_GUIDES' 
export const GET_GUIDES_SUCCESS = 'GET_GUIDES_SUCCESS' 
export const GET_GUIDES_FAILURE = 'GET_GUIDES_FAILURE' 

export const POST_DATA = 'POST_DATA'
export const POST_DATA_SUCCESS = 'POST_DATA_SUCCESS'
export const POST_DATA_FAILURE = 'POST_DATA_FAILURE'

export const SET_USER_DATA = 'SET_USER_DATA' 